const initialised = new WeakSet();

export function setupCookiePreferences(root, hostWindow) {
  const groups = [...(root.matches?.('[data-mm-cookie-preferences]') ? [root] : []), ...root.querySelectorAll('[data-mm-cookie-preferences]')];
  groups.forEach(group => {
    if (initialised.has(group)) return;
    const button = group.querySelector('button');
    const status = group.querySelector('[role="status"]');
    if (!button || !status) return;
    initialised.add(group);
    button.hidden = false;
    button.addEventListener('click', async () => {
      if (button.disabled) return;
      status.hidden = true;
      status.textContent = '';
      button.disabled = true;
      try {
        // Shopify owns the modal and records choices made inside it.
        if (typeof hostWindow.privacyBanner?.showPreferences !== 'function') throw new Error('Unavailable');
        await hostWindow.privacyBanner.showPreferences();
      } catch {
        status.textContent = 'Cookie preferences could not open. Please refresh the page and try again.';
        status.hidden = false;
      } finally {
        button.disabled = false;
      }
    });
  });
}

if (typeof document !== 'undefined') {
  setupCookiePreferences(document, window);
  document.addEventListener('shopify:section:load', event => setupCookiePreferences(event.target, window));
}
